// extracted by mini-css-extract-plugin
module.exports = {"periodsTable":"PeriodsList_periodsTable__3_xfP"};